const translations = {
  "en": {
    "Give me more info about this news": "Give me more info about this news",
    "Read News": "Read News",
    "View Summary": "View Summary"
  },
  "zh-tw": {
    "Give me more info about this news": "了解新聞詳情",
    "Read News": "查看新聞",
    "View Summary": "查看摘要"
  }
};

export default translations;
